
  import '/Users/jilin/projects/antd/rc-dialog/docs/examples/pure.tsx?watch=parent';
  export default "import React from 'react';\nimport { Panel } from 'rc-dialog';\nimport 'rc-select/assets/index.less';\nimport '../../assets/index.less';\n\nconst Demo: React.FC = () => (\n  <Panel prefixCls=\"rc-dialog\" title=\"Title\" closable>\n    Hello World!\n  </Panel>\n);\n\nexport default Demo;\n";;
  